import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../zodios/client";

type GetAssetsArg = NonNullable<Parameters<typeof apiClient.getAssets>[0]>;
type AssetQueryParams = NonNullable<GetAssetsArg["queries"]>;

export const useAssets = (queries: AssetQueryParams = {}) => {
  return useQuery({
    queryKey: ["assetSearch", queries],
    queryFn: async () => await apiClient.getAssets({ queries }),
  });
};
